import {
  Dialog,
  DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface Props {
  maxWidth?: string | number
}

/**
 * If you want the Modal to take certain width you need to set these two props:
 * fullWidth - to make the Modal take the full maxWidth.
 * maxWidth - to set the max width of the Modal.
 *
 * Notes there is another prop called fullScreen that makes the modal takes the full screen size.
 */

const Modal = ({
  title,
  children,
  onClose,
  maxWidth,
  ...props
}: Omit<DialogProps, 'maxWidth'> & Props) => {
  const theme = useTheme()
  return (
    <Dialog
      {...props}
      sx={{
        ...props.sx,
        overflow: 'unset',
        '& .MuiDialog-paper': { maxWidth }
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            m: 0,
            p: 1,
            borderBottom: '1px solid',
            borderColor: theme.extraColors.border
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            sx={{ justifyContent: 'space-between', width: '100%' }}
          >
            <Typography
              id="modal-modal-title"
              variant="subtitle1"
              sx={{ mx: 1 }}
            >
              <strong>{title}</strong>
            </Typography>
            {onClose && (
              <IconButton
                onClick={(e) => {
                  onClose(e, 'backdropClick')
                }}
                sx={{ p: 0 }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Stack>
        </DialogTitle>
      )}
      {children}
    </Dialog>
  )
}

export default Modal
